import React from 'react'
import { Divider, Row, Form, Button, Input, Switch, notification } from 'antd'
import { Link } from 'react-router-dom'
import API from '../../services/API'
import Segment from '../../components/Segment'

const INIT = {
    name: '',
    percent_value: '',
    active: true,
}

const CustomerTypesEditContainer = ({ match }) => {
    const [data, setData] = React.useState(INIT)
    const [loading, setloading] = React.useState(false)
    const disabled = !data.name || !data.percent_value


    const getData = () => {
        setloading(true)
        API.get(`/api/customer_types/${match.params.id}`)
            .then(response => {
                setData(response.data)
                setloading(false)
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    React.useEffect(() => {
        getData()
    }, [])

    const handleChange = (name, value) => {
        const newData = { ...data }
        newData[name] = value
        setData(newData)
    }

    const handleSubmit = e => {
        setloading(true)
        e.preventDefault()

        API.patch(`/api/customer_types/${match.params.id}`, data)
            .then(() => {
                setloading(false)
                notification.success({
                    message: 'El tipo de precio se ha guardado exitosamente',
                })
            })
            .catch(error => {
                setloading(false)
                notification.error({ message: error.message })
            })
    }

    return (
        <Segment loading={loading}>
            <Divider>Tipo de precio</Divider>

            <Form style={{ maxWidth: '400px', margin: 'auto' }}>
                <p className="message">
                    Todos los campos marcados con un asterisco (<span>*</span>) son campos obligatorios y deben ser
                    llenados.
                </p>

                <Form.Item label="Nombre" className="required" hasFeedback>
                    <Input
                        placeholder="Nombre"
                        value={data.name}
                        onChange={e => {
                            handleChange('name', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Porcentaje" className="required" hasFeedback>
                    <Input
                        placeholder="Porcentaje"
                        value={data.percent_value}
                        onChange={e => {
                            handleChange('percent_value', e.target.value)
                        }}
                    />
                </Form.Item>

                <Form.Item label="Activo" hasFeedback>
                    <Switch
                        checked={!!data.active}
                        onChange={value => {
                            handleChange('active', value)
                        }}
                    />
                </Form.Item>

                <Row type="flex" justify="space-between" style={{ marginTop: '50px' }}>

                    <Form.Item>
                        <Link to="/customer_types">
                            <Button

                                icon="arrow-left"
                            >
                                Regresar
                            </Button>
                        </Link>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            icon="save"
                            disabled={disabled}
                            onClick={handleSubmit}
                        >
                            Guardar
                        </Button>
                    </Form.Item>
                </Row>




            </Form>
        </Segment>
    )
}

export default CustomerTypesEditContainer
